import { createFileRoute, Navigate } from "@tanstack/react-router";
import { Spinner } from "@/components/ui/spinner";
import { ConsentForm } from "@/features/onboarding/_components/consent-form";
import { useMe } from "@/hooks/use-me";
import { PDPA_CONSENT_VERSION } from "@/lib/pdpa-consent";

export const Route = createFileRoute("/onboarding/consent")({
	component: ConsentPage,
});

function ConsentPage() {
	const me = useMe();

	if (me === undefined) {
		return (
			<div className="flex justify-center py-16">
				<Spinner className="size-6" />
			</div>
		);
	}

	if (me?.pdpaConsent?.version === PDPA_CONSENT_VERSION) {
		return <Navigate to="/onboarding/create-organization" replace />;
	}

	return <ConsentForm />;
}
